import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.css";
import Home from "./components/Home";
import Home2 from "./components/Home2";
import Home3 from "./components/Home3";
// import { useEffect } from "react";
// import { generateToken, messaging} from "./notifications/firebase";
// import { onMessage } from "firebase/messaging";
// import toast, { Toaster } from 'react-hot-toast';

function App() {
  // useEffect(()=>{
  //   generateToken();
  //   onMessage(messaging,(payload)=>{
  //     console.log(payload)
  //     toast(payload.notification.body);
  //   })
  // },[])

  return (
    <div className="App">
      {/* <Toaster position="top-right"/> */}
      <Router>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/:alias">
            <Home />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
